import React, { Component } from 'react';
import { ReferenceField } from 'app-types';
import classNames from 'classnames';
import { LabeledValue } from 'components';
import { chunk, isEmpty } from 'lodash-es';

interface Props {
	referenceFields?: ReferenceField[];
	title?: string;
	className?: string;
	numOfItemsInRow?: number;
	itemGridWidth?: number;
}

const GRID_COLS = 12;
const DEFAULT_NUMBER_OF_ITEMS_IN_ROW = 3;

export default class ReferenceFieldsDisplay extends Component<Props> {
	getReferenceFields() {
		const {
			referenceFields = [],
			numOfItemsInRow = DEFAULT_NUMBER_OF_ITEMS_IN_ROW,
			itemGridWidth,
		} = this.props;

		return referenceFields.map(field => {
			return (
				<div
					key={`reference-fields-cell-${field.customerReferenceFieldId}`}
					className={`modalBoxCol w${itemGridWidth || GRID_COLS / numOfItemsInRow}`}
				>
					<LabeledValue label={field.referenceFieldName} value={field.value} />
				</div>
			);
		});
	}

	render() {
		const { title, className, numOfItemsInRow = DEFAULT_NUMBER_OF_ITEMS_IN_ROW } = this.props;
		const referenceFields = this.getReferenceFields();
		const chunkedReferenceFields = chunk(referenceFields, numOfItemsInRow);

		if (isEmpty(chunkedReferenceFields)) {
			return null;
		}

		return (
			<div className={classNames(className)}>
				{title && <h3>{title}</h3>}
				{chunkedReferenceFields.map((chunk, index) => (
					<div className="modalBoxRow" key={`reference-fields-row-${index}`}>
						{chunk}
					</div>
				))}
			</div>
		);
	}
}
